module.exports = __webpack_public_path__ + "static/media/10-0_10.1--thumb.1399ba2c.png";